<template>
    <div id="memberInfo" v-loading="loading">
        <!-- PC端内容 -->
        <div class="page flex-col" v-if="!isMobile">
            <div class="box_1 flex-col">
                <div class="p_img">
                    <a href="javascript:;">
                        <img src="../../../assets/client/banner_9.png" alt="分子公司" title="分子公司">
                    </a>
                </div>
                <div class="p_info">
                    <div>
                        <h2 class="text-white p_btitle">分子公司</h2>
                        <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
                    </div>
                </div>
            </div>
            <div class="box_3 flex-col justify-end">
                <div class="group_2 flex-row">
                    <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;分子公司&nbsp;&gt;&nbsp;{{memberInfo.short_name}}</span>
                    <div class="text-wrapper_6_be">
                        <transition  name="slide">
                            <div class="text-wrapper_1 flex-col" v-if="telshow">
                                <span class="text_14">4001-300-137</span>
                            </div>
                        </transition>
                    </div>
                    <div class="box_8_1">
                        <div class="box_4 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                            <div class="image-text_1 flex-col justify-between">
                                <img class="label_1" referrerpolicy="no-referrer" src="../../../assets/client/icon_lxfs.png" />
                                <span class="text-group_1">业务咨询</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="group_3 flex-row justify-between">
                    <table>
                        <tr>
                            <td>
                                <img class="image_4" referrerpolicy="no-referrer" :src="FileAddress+memberInfo.FilePath" @load="resizeImage" />
                            </td>
                            <td>
                                <span class="text_15">{{memberInfo.full_name}}</span>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="group_5 flex-col"></div>
                <div class="group_6 flex-row justify-between">
                    <div class="group_7 flex-col"></div>
                    <span class="text_16">公司介绍</span>
                </div>
                <div class="text-wrapper_2" v-html="memberInfo.company_desc"></div>
                <div class="group_8 flex-row justify-between">
                    <div class="box_5 flex-col"></div>
                    <span class="text_18">业务领域</span>
                </div>
                <div class="text-wrapper_2" v-html="memberInfo.business_field"></div>
                <div class="text-wrapper_3 flex-col"></div>
            </div>
        </div>

        <!-- 移动端内容 -->
        <div class="mobile-memberinfo-container" v-if="isMobile">
            <!-- Banner区域 -->
            <div class="mobile-memberinfo-banner">
                <img class="mobile-memberinfo-banner__image" src="../../../assets/client/banner_9.png" alt="分子公司" />
                <div class="mobile-memberinfo-banner__overlay"></div>
                <div class="mobile-memberinfo-banner__content">
                    <h1 class="mobile-memberinfo-banner__title">分子公司</h1>
                    <p class="mobile-memberinfo-banner__subtitle">SAILHERO ENVIRONMENTAL PROTECTION</p>
                </div>
            </div>

            <!-- 面包屑导航 -->
            <div class="mobile-memberinfo-breadcrumb">
                <p class="mobile-memberinfo-breadcrumb__text">
                    首页 > 分子公司 > <span class="mobile-memberinfo-breadcrumb__current">{{ memberInfo.short_name }}</span>
                </p>
            </div>

            <!-- 公司信息头部 -->
            <div class="mobile-memberinfo-header">
                <div class="mobile-memberinfo-header__logo-wrapper">
                    <img 
                        class="mobile-memberinfo-header__logo" 
                        :src="FileAddress + memberInfo.FilePath" 
                        :alt="memberInfo.full_name"
                    />
                </div>
                <h2 class="mobile-memberinfo-header__name">{{ memberInfo.full_name }}</h2>
                <div class="mobile-memberinfo-header__divider"></div>
            </div>

            <!-- 公司介绍 -->
            <div class="mobile-memberinfo-section">
                <div class="mobile-memberinfo-section__header">
                    <div class="mobile-memberinfo-section__indicator"></div>
                    <h3 class="mobile-memberinfo-section__title">公司介绍</h3>
                </div>
                <div class="mobile-memberinfo-section__content" v-html="memberInfo.company_desc"></div>
            </div>

            <!-- 业务领域 -->
            <div class="mobile-memberinfo-section">
                <div class="mobile-memberinfo-section__header">
                    <div class="mobile-memberinfo-section__indicator"></div>
                    <h3 class="mobile-memberinfo-section__title">业务领域</h3>
                </div>
                <div class="mobile-memberinfo-section__content" v-html="memberInfo.business_field"></div>
            </div>
        </div>
    </div>
</template>
<script>
import "../../../assets/client/memberInfo.css";
import "../../../assets/client/memberInfo-mobile.css";
export default{
    data() {
        return {
            FileAddress: process.env.VUE_APP_FileAddress.replace('fileapi/', ''),
            memberInfo: { full_name: "", short_name: "", company_desc: "", business_field: "" },
            loading:false,
            telshow:false,
            isMobile: false,
            lastDeviceType: null,
        }
    },
    methods: {
        getData() {
            let that = this;
            if (that.$route.query.id) {
                that.loading = true;
                that.memberInfo = { full_name: "", short_name: "", company_desc: "", business_field: "" };
                that.$api.post("/Client/getMemberDataById", { id: that.$route.query.id },
                    function (res) {
                        if (res.code === "200") {
                            that.memberInfo = res.data;
                        }
                        that.loading = false;
                    },
                    function (res) {
                        that.loading = false;
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            }
        },
        resizeImage(event) {
            const img = event.target;
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            img.style.width = `${width}px`;
            img.style.height = `${height}px`;
        },
        handleMouseEnter(){
        let that = this;
        that.telshow = true;
        },
        handleMouseLeave(){
            let that = this;
            that.telshow = false;
        },
        checkMobile() {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth <= 768;
            
            // 检测设备类型变化
            const currentDeviceType = this.isMobile ? 'mobile' : 'pc';
            if (this.lastDeviceType && this.lastDeviceType !== currentDeviceType) {
                // 设备类型发生了变化，需要重新加载数据
                this.getData();
            }
            this.lastDeviceType = currentDeviceType;
        }
    },
    mounted() {
        this.$parent.$refs.menu.setActiveIndex("9");
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    watch: {
        '$route.query.id': {
            handler: function (to, from) {
                this.getData();
            },
            immediate: true // 立即触发
        }
    }
}
</script>
<style scoped>
          .slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }
    .slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
        transform: translateX(22.53vw);
    }

    .p_img img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        animation: bannerimg 2s;
    }

    .p_info .p_btitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 59px;
        font-weight: 900;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .p_info .p_subtitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 1.458333vw;
        font-weight: 400;
        position: relative;
        bottom: 3.125vw;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        letter-spacing: 0.05625vw;
    }

    .p_info {
        width: 100%;
        max-width: 1600px;
        padding: 0 5px;
        position: absolute;
        left: 257px;
        top: 120px;
        letter-spacing: 3px;
        z-index: 9;
    }

    @keyframes puBanner {
        from {
            transform: translateY(200px);
            opacity: 0
        }

        to {
            transform: translateY(0);
            opacity: 1
        }
    }

    @keyframes bannerimg {
        from {
            transform: scale(1.15)
        }

        to {
            transform: scale(1);
        }
    }
</style>
